export const standards = {
  Add_new_requirement: "Add new requirement",
  Add_requirement: "Add requirement",
  Add_section: "Add New Section",
  Add_subsection: "Add subsection",
  All_Clients: "All Clients",
  Content: "Content",
  Edit_requirement: "Edit requirement",
  Expand_all: "Expand all",
  Full_name: "Full name",
  Please_fill_in_the_requirement_information: "Please fill in the requirement information",
  Published_date: "Publish date",
  Read_less: "Read less",
  Read_more: "Read more",
  Reference: "Reference",
  Requirement_Info: "Requirement Info",
  Section_Reference: "Section Reference",
  Section_reference_is_required: "Section reference is required",
  Section_title: "Section title",
  Section_title_is_required: "Section title is required",
  Section_with_this_reference_already_exists: "Section with this reference and title already exists",
  Sections: "Sections",
  Standard_Body: "Standard Body",
  Standard_Guidance: "Standard Guidance",
  Standard_ID: "Standard ID",
  Sub_Section_with_this_title_already_exists: "Sub Section with this reference and title already exists",
  Sub_Sections: "Sub Sections",
  "Sub-Section_Reference": "Sub-Section Reference",
  "Sub-Section_title": "Sub-Section title",
  Tenants: "Tenants",
  This_cannot_be_deleted_until_all_the_associated_requirements_and_sub_sections_are_removed_first:
    "This cannot be deleted until all the associated requirements and sub sections are removed first.",
  This_cannot_be_deleted_until_all_the_associated_requirements_are_removed_first:
    "This cannot be deleted until all the associated requirements are removed first.",
  Version: "Version",
  You_are_adding_a_new_requirement_to: "You are adding a new requirement to:",
} as const;
